import moment from 'moment'
export function formatDate(date, format){
    format = format || 'YYYY-MM-DD HH:mm:ss';
    if(date){
        return moment(date).format(format)
    }else{
        return '暂无'
    }
    
}

// 格式化字符串时间，例如：'20260318101400' 转换为 '2026-03-18 10:14:00'
export function formatStringDate(date, format){
    format = format || 'YYYY-MM-DD HH:mm:ss';
    if(date){
        let dateStr = date.substr(0,4) + '-' + date.substr(4,2) + '-' + date.substr(6,2) + ' ' + date.substr(8,2) + ':' + date.substr(10,2) + ':' + date.substr(12,2)
        return moment(dateStr).format(format)
    }else{
        return '暂无'
    }
}


export function toFixed(num, n){
    if(num){
        num = num*1
        return num.toFixed(n)
    }else{
        return '--'
    }
    
}


// WEBPACK FOOTER //
// ./src/util/filter.js